import { Box, styled } from '@mui/material';

const QueueContainer = styled(Box, {
  name: 'queue-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  padding: '0',
}));

const HeaderContainer = styled(Box, {
  name: 'header-container',
  slot: 'Root',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1),
  width: '100%',
  // borderBottom: `1px solid ${theme.palette.primary.main}`,
}));

const QueueContentContainer = styled(Box, {
  name: 'queue-content-container',
  slot: 'Root',
})({
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  marginTop: '8px',
  flex: 1,
  overflow: 'hidden',
  minHeight: 0,
});

const EntityDetailsContainer = styled(Box, {
  name: 'entity-details-container',
  slot: 'Root',
})(() => ({
  width: '100%',
  display: 'grid',
  // 2 : 1 column ratio (was 4 : 1). Pulls the right-column values closer
  // to the labels on the left, so the ViewPanel doesn't feel like it's
  // pinning small fields to the far edge of the panel. Only used on the
  // collapsed / compact ViewPanel — the expanded view renders its own
  // section-card layout via TarReadOnlyView.
  gridTemplateColumns: '2fr 1fr',
  gridTemplateRows: '0.1fr 0.1fr',
  gap: '16px',
}));

export {
  EntityDetailsContainer,
  HeaderContainer,
  QueueContainer,
  QueueContentContainer,
};
